import classNames from 'classnames/bind';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import styles from './TopBar.module.scss';

import AccountCircle from '@/components/ui/AccountCircle';
import Bar from '@/components/ui/Bar';
import Select from '@/components/ui/kit/Select';

const cx = classNames.bind(styles);
const SHECO_TARGET_USER_IDS = ['26aac90e-7ff8-4d70-8e46-276a8faadb22', '73b8a10a-4c7f-4ce7-b9f3-019d9c2c4791'];

const TopBar = ({ children }) => {
  const location = useLocation();
  const userId = useSelector((state) => state.user?.id);

  const key = useMemo(() => {
    return location.pathname.split('/')[1];
  }, [location]);

  const childrenWithBars = useMemo(() => {
    const childArray = React.Children.toArray(children);
    if (childArray.length <= 1) return children;

    return childArray.reduce((acc, child, index) => {
      if (index > 0) acc.push(<Bar key={`bar-${index}`} size={20} />);
      acc.push(child);
      return acc;
    }, []);
  }, [children]);

  const title = useMemo(() => {
    if (key === 'control-center') {
      return 'Control Center';
    } else if (key === 'mission-hub') {
      return 'Mission Hub';
    }
  }, [key]);

  const isShowSelect = useMemo(() => {
    return ['control-center', 'mission-hub'].includes(key);
  }, [key]);

  const handleChange = (e) => {
    if (e.target.value === 'sheco') {
      window.open('http://119.197.203.104:31007/auto-login', '_blank', 'noopener,noreferrer');
    } else {
      window.open(`/${e.target.value}`);
    }
  };

  return (
    <div className={cx('container')}>
      <div className={cx('left')}>
        <img src={require('@/assets/images/logo.png')} alt="M1UCS" />
        <div className={cx('wordmark')}>
          <div className={cx('app')}>M1UCS</div>
          <div className={cx('title')}>{title}</div>
        </div>
      </div>
      <div className={cx('center')}>{childrenWithBars}</div>
      <div className={cx('right')}>
        {isShowSelect && (
          <Select value={key} onChange={handleChange} className={cx('select')}>
            <option value="control-center">Control Center</option>
            <option value="mission-hub">Mission Hub</option>
            {SHECO_TARGET_USER_IDS.includes(userId) && <option value="sheco">Sheco Board</option>}
          </Select>
        )}
        <AccountCircle />
      </div>
    </div>
  );
};

export default TopBar;
